import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Typography } from '@material-ui/core';
import fr from 'facet-rest';
import { GetAppUrl } from 'Consts/sharedUris';
import { clientSchedulerUri } from 'Consts/clientUris';
import { copyToClipboard } from 'Helpers/Utils';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import history from 'State/history';
import { advisorHouseholdSchedulerUri } from 'Consts/advisorUris';
import moment from 'moment-timezone';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import CancelMeetingButton from 'Components/ComponentLibrary/Components/Buttons/CancelMeetingButton';
import ShareRescheduleMeetingLinkButton from 'Components/ComponentLibrary/Components/Buttons/ShareRescheduleMeetingLinkButton';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: 350,
    padding: theme.spacing(0, 1),
    textAlign: 'left',
    '& > *:not(:first-child)': {
      marginBottom: theme.spacing(1),
    },
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'center',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  meetingSubtitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  meetingSubtitle: {
    color: theme.palette.facet.primaryGray,
    fontSize: 14,
  },
});

const CancelMeetingEventHoverLayout = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();
  const { resource, onSubmit } = useMetaLayoutContext();
  const { logEvent } = useEventTrackingLogEvent();

  const handleCancelMeeting = async () => {
    logEvent('Cancel Meeting in Mission Control');
    try {
      await resource.relationship(fr.relationships.calendarEvent.name).link('related').delete();
      onSubmit(resource);
      displaySuccess('Successfully cancelled meeting');
    } catch (err) {
      displayErrorMessage(err, 'Failed to cancel meeting');
    }
  };

  const handleShareRescheduleLink = () => {
    logEvent('Share Reschedule Meeting Link');
    try {
      const availabilityPeriodLink = resource.relationship(fr.relationships.rescheduleMeeting.name).link('related').url();
      const schedulerLink = `${GetAppUrl()}${clientSchedulerUri}`;
      const schedulerUrl = new URL(schedulerLink);
      schedulerUrl.searchParams.set('link', availabilityPeriodLink);
      copyToClipboard(schedulerUrl.toString());
      displaySuccess('Copied link to clipboard');
    } catch (err) {
      displayErrorMessage(err, 'Failed to copy link');
    }
  };

  const handleRescheduleClick = () => {
    logEvent('Clicked Reschedule Meeting');
    history.push(advisorHouseholdSchedulerUri(householdResource.id(), {
      link: resource.relationship(fr.relationships.rescheduleMeeting.name).link('related').url({
        tz: moment.tz.guess(),
      }),
    }));
  };


  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classes.meetingSubtitleContainer}>
        <Typography className={classes.meetingSubtitle}>
            Meeting Details
        </Typography>
        <div className={classes.actionContainer}>
          <CancelMeetingButton onClick={handleCancelMeeting} />
          <ShareRescheduleMeetingLinkButton onClick={handleShareRescheduleLink} />
        </div>
      </div>
      <MetaControlField attr="startTime" onClick={handleRescheduleClick} />
      <MetaControlField attr="meetingType" />
      <MetaControlField attr="meetingHeldStatus" />
    </Box>
  );
};

CancelMeetingEventHoverLayout.defaultProps = {
  className: '',
};

CancelMeetingEventHoverLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CancelMeetingEventHoverLayout);
